/* 
    可选区域组件
    created by: liyaoh 2019-04-11
*/
import React, { Component } from 'react';
import { langCheck } from 'Pub/js/utils';
import { connect } from 'react-redux';
import DragArea from '../DragArea';
import AreaTypeItem from './AreaTypeItem';
import { updateAreaList, updateSelectArea } from 'Store/ZoneSetting/action';
import { addNewAreaItem } from '../../events';

class AreaType extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render(){
        const { json } = this.props;
        const areaTypeMap = [
            { areacode: '0', name: langCheck('102202APP-000033', 'pages', json), icon: 'ncc-pt-cxq' },/* 国际化处理： 查询区*/
            { areacode: '1', name: langCheck('102202APP-000032', 'pages', json), icon: 'ncc-pt-bdq' },/* 国际化处理： 表单区*/
            { areacode: '2', name: langCheck('102202APP-000031', 'pages', json), icon: 'ncc-pt-bgq' } /* 国际化处理： 表格区*/
        ];
        const areaTypeHeader = (
            <div>
                <div className="tip">
                    <i className="iconfont icon-zhuyi1" />
                    {/* 国际化处理： 请点击/拖拽以下区域至右侧页面 */}
                    {langCheck('ZoneSetting-000197', 'pages', json)}
                </div> 
                <span className="title">{langCheck('ZoneSetting-000196', 'pages', json)}</span> {/* 国际化处理： 可选区域 */}
            </div>
        );
        return (
            <DragArea
                renderHeader={areaTypeHeader}
                onDragItemClick={(item) => addNewAreaItem(this.props, {
                    items: { areatype: item.items.areacode },
                    isExpand: true
                })}
            >
                {
                    areaTypeMap.map(item => {
                        return <AreaTypeItem items={item}/>
                    })
                }
            </DragArea>
        )
    }
}

export default connect(state => ({
    areaList: state.zoneSettingData.areaList
}),
    {
        updateAreaList,
        updateSelectArea
    }
)(AreaType);